<script lang="ts" setup>
import { computed } from 'vue'
import IconDocument from '@lahaus-roomie/roomie/src/assets/icons/document.svg'
import type { Props } from './types'

import AppImagesGrid from '@/components/App/ImagesGrid/index.vue'

const props = defineProps<Props>()
const showDocument = computed(() => props.attachments[0].media_type === 'document')

const images = computed(() => props.attachments.filter(attachment => attachment.media_type === 'image').map(attachment => attachment.media_url))
</script>

<script lang="ts">
export default {
  name: 'AppChatMigratedAttachments'
}
</script>

<template>
  <template v-if="showDocument">
    <a
      v-for="(document, index) in attachments"
      :key="`document-${index}`"
      class="w-full flex items-center gap-4"
      :href="attachments[0].media_url"
      :data-lh-id="`${screen}-app-chat-button-open-document-attachment`"
      target="_blank">
      <IconDocument class="fill-primary-600 w-24 h-24 pointer-events-none" />

      <p class="text-primary-600 underline pointer-events-none ">
        {{ listingName }}
      </p>
    </a>
  </template>

  <AppImagesGrid
    v-else
    :id="`${screen}-app-chat`"
    :images
    :max-images-in-grid="4"
    :image-multiplier="7" />
</template>
